import React, { useState, useRef, useEffect } from "react";
import { DownArrow } from "../icons";
import "./generalDropDown.scss";

const GeneralDropdown = ({
  options,
  value,
  onChange,
  placeholder = "Select…",
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  // Decide what to render in the trigger:
  const selectedLabel =
    options.find((o) => o.value === value)?.label || placeholder;

  return (
    <div ref={ref} className={`general-dropdown ${className}`}>
      <div className="trigger" onClick={() => setIsOpen((o) => !o)}>
        <span className="label">{selectedLabel}</span>

        <span className={`arrow ${isOpen ? "open" : ""}`}>
          <DownArrow width="16" height="16" fillColor="var(--color-darkGold)" />
        </span>

        {/* Only show this when something is selected */}
        {value && (
          <button
            className="reset-btn"
            onClick={(e) => {
              e.stopPropagation(); // don’t re-open the list
              onChange(""); // clear selection
            }}
          >
            Reset
          </button>
        )}
      </div>

      {isOpen && (
        <div className="list">
          {options.map((choice) => (
            <div
              key={choice.value}
              className={`item ${choice.value === value ? "selected" : ""}`}
              onClick={() => {
                onChange(choice.value);
                setIsOpen(false);
              }}
            >
              {choice.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GeneralDropdown;
